import { render, staticRenderFns } from "./IncidenteMedicoIcon.vue?vue&type=template&id=9602fcb2&scoped=true"
import script from "./IncidenteMedicoIcon.vue?vue&type=script&lang=js"
export * from "./IncidenteMedicoIcon.vue?vue&type=script&lang=js"
import style0 from "./IncidenteMedicoIcon.vue?vue&type=style&index=0&id=9602fcb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9602fcb2",
  null
  
)

export default component.exports